import Vue from 'vue'
import App from './App.vue'
import router from './router'
import element from './element/index'
import echarts from 'echarts'
import china from 'echarts/map/json/china.json'
import BaiduMap from 'vue-baidu-map'
import store from './store'
// import request from './utils/request'
import moment from 'moment'

//全局引入公共组件
import './components/componentRegister'

// 兼容IE10 MouseEvent
;(function(window) {
  try {
    new MouseEvent('test')
    return false // No need to polyfill
  } catch (e) {
    // Need to polyfill - fall through
  }

  // Polyfills DOM4 MouseEvent

  var MouseEvent = function(eventType, params) {
    params = params || { bubbles: false, cancelable: false }
    var mouseEvent = document.createEvent('MouseEvent')
    mouseEvent.initMouseEvent(
      eventType,
      params.bubbles,
      params.cancelable,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    )

    return mouseEvent
  }

  MouseEvent.prototype = Event.prototype

  window.MouseEvent = MouseEvent
})(window)

Vue.use(BaiduMap, {
  ak: 'Um6pakYeNEvoTvi7W7v8fbrmlUnZSdus' //百度官方提供的ak密钥
})
Vue.use(element)

Vue.prototype.$echarts = echarts
// Vue.prototype.$http = request
echarts.registerMap('china', china)

Vue.filter('dateFormat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  mounted() {
    // document.dispatchEvent(new Event('render-event'))
    document.dispatchEvent(new Event('custom-render-trigger'))
  },
  render: h => h(App)
}).$mount('#app')
